import React, { useEffect, useState } from 'react'
import Navigation from './Navigation'
import { useTranslation } from 'react-i18next';
import './i18n';  // Import the i18n setup
const App = () => {
  return (
    <>
      <Navigation />
    </>
  )
}

export default App